exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer__menu-list[data-v-3dd11c50]{display:inline-block;vertical-align:top;list-style-type:none}.footer__menu-list-item[data-v-3dd11c50]{margin-bottom:6px}.menu-nav[data-v-3dd11c50],.menu-text[data-v-3dd11c50]{color:#485b84;text-decoration:none;font-size:14px}.menu-nav[data-v-3dd11c50]:hover{color:#51acff;text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3dd11c50","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/nav/Footer.vue
// module id = cd82b2f18ca86fef1c5f
// module chunks = 0